// grid component that displays projects as cards
import styles from './styles.module.css';
import React, { useEffect, useRef, useState } from 'react';

import GridItem, { GridItemProps } from './GridItem';
import DropdownWithCheckboxes from '../DropdownWithCheckboxes';

type GridProps = {
    projects: GridItemProps[];
    comingSoonProjects?: GridItemProps[];
};

export default function Grid({ projects, comingSoonProjects = [] }: GridProps) {
    const allTags = Array.from(new Set([...projects, ...comingSoonProjects].reduce<string[]>((acc, project) => {
        if (project.tags) {
            return [...acc, ...project.tags];
        }
        return acc;
    }, [])));

    const [selectedTags, setSelectedTags] = useState<string[]>(allTags);

    const displayedProjects = projects.filter(project => {
        if (!project.tags) {
            return true;
        }
        return project.tags.some(tag => selectedTags.includes(tag));
    });

    const displayedComingSoonProjects = comingSoonProjects.filter(project => {
        if (!project.tags) {
            return true;
        }
        return project.tags.some(tag => selectedTags.includes(tag));
    });

    return <>
        <div className={`${styles.gridContainer}`}>
            {displayedProjects.map((project, index) => {
                return (
                    <GridItem
                        key={project.title + project.subtitle}
                        type={project.type}
                        title={project.title}
                        subtitle={project.subtitle}
                        href={project.href}
                        contentTags={project.contentTags}
                        onClick={project.onClick}
                        SvgIcon={project.SvgIcon}
                        SvgIconOnHover={project.SvgIconOnHover}
                        tags={project.tags}
                        isComingSoon={project.isComingSoon}
                        beforeNavigationCallback={project.beforeNavigationCallback}
                    />
                )
            })}
        </div>
        {displayedComingSoonProjects.length > 0 && (
            <div>
                <hr style={{ width: "80%", margin: "0 auto", marginTop: "50px", marginBottom: "50px" }} />
                <h1 style={{ textAlign: "center", fontSize: "2em", marginBottom: "50px" }}>Coming Soon</h1>
                <hr style={{ width: "80%", margin: "0 auto", marginTop: "50px", marginBottom: "50px" }} />
            </div>
        )}
        <div className={`${styles.gridContainer}`}>
            {displayedComingSoonProjects.map((project, index) => {

                return (<GridItem
                    key={project.title + project.subtitle}
                    type={project.type}
                    title={project.title}
                    subtitle={project.subtitle}
                    href={project.href}
                    contentTags={project.contentTags}
                    onClick={project.onClick}
                    SvgIcon={project.SvgIcon}
                    SvgIconOnHover={project.SvgIconOnHover}
                    tags={project.tags}
                    isComingSoon={project.isComingSoon}
                    beforeNavigationCallback={project.beforeNavigationCallback}
                />);
            })}
        </div>
        {!!allTags.length && <div className={styles.filterByContainer}>
            <DropdownWithCheckboxes items={allTags} onCheckedChange={(checkedTags) => setSelectedTags(checkedTags)} />
        </div>}
    </>;
}
